// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixData from 'wix-data';

$w.onReady(function () {
	// Write your JavaScript here
	// To select an element by ID use: $w("#elementID")
	// Click "Preview" to run your code
});

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function selectionTags1_click(event) {
	let selectedTags = $w("#selectionTags1").value;

    // Define an empty filter
    let filter = wixData.filter();
    if (selectedTags) {
        // Build a filter that only includes items with all selected tags
		
		selectedTags.forEach(tag => {
			filter = filter.contains("description", tag.toString());
		});
		console.log(filter);
        // filter = filter.hasAll("description", selectedTags);
		
    }

    $w('#dataset1').setFilter(filter);
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

// TODO: default image for missing images.
// let defaultImage = 'https://static.wixstatic.com/media/1bcec4_670aae5271c940a194d147a463168808~mv2.png';

// $w.onReady( function() {
// 	$w("#repeater1").forEachItem( ($item, itemData, index) => {
// 		if(!itemData.image) {
// 			$item("#image2").src = defaultImage;
// 		}
// 		console.log($item("#image2").src);
// 		console.log($item('#text19').text);
// 	})
// });
